import {
  DashbaordAlertSendMessage,
  DashboarAlertLatest,
} from "api/interfaces/dashboardInterface.interface";
import { useState } from "react";
import AlertItem from "./AlertItem";
import { AssignModalType } from "utils/WidgetUtil";

type Props = {
  data: DashboarAlertLatest[];
};

export default function AlertList(props: Props) {
  const [selectedAlertItem, setSelectedAlertItem] =
    useState<DashbaordAlertSendMessage>({
      alertRuleId: "",
      recorderId: "",
    });
  const [isAssignModal, setIsAssignModal] = useState<AssignModalType>({
    phone: false,
    email: false,
  });
  const [assignInfo, setAssignInfo] = useState<{ [key: string]: string }>({
    phone: "",
    email: "",
  });
  const onAssignModal = (type: string, value?: string) => {
    if (value !== undefined) {
      setAssignInfo({
        ...assignInfo,
        [type]: value,
      });
    }

    setIsAssignModal({
      ...isAssignModal,
      [type]: !isAssignModal[type],
    });
  };
  const onSelectItem = (item: DashboarAlertLatest) => {
    setSelectedAlertItem({
      alertRuleId: item.alertRuleId,
      recorderId: item.recorderId,
    });
  };
  return (
    <>
      {props.data.map((item: any, index: number) => (
        <AlertItem
          data={item}
          key={`dashboard-alert-item-${index}`}
          onAssignModal={onAssignModal}
          onSelectItem={onSelectItem}
        />
      ))}
    </>
  );
}
